export default "__VITE_ASSET__C69nu94h__"